import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useAlert } from 'react-alert';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import apiCep from '../../api/apiCep';
import { getTotem } from '../../api/apiFactory';
import {
  fetchBairros, fetchEscolaridades, fetchEstadosTurismo, fetchFicouSabendo,
  fetchSolicitanteCampos, postCadastrarSolicitante, fetchCidadesTurismo, fetchSolicitanteCamposTotem, postCadastrarSolicitanteTotem,
} from '../../api/endpoints';
import { desfazerBairro, selectBairroTotem } from '../../app/slices/bairroTotemSlice';
import { desfazerCidade, selectCidade } from '../../app/slices/cidadesSlice';
import { desfazerComoSoube, selectComoSoubeTotem } from '../../app/slices/comoSoubeTotemSlice';
import { desfazerEscolaridade, selectEscolaridadeTotem } from '../../app/slices/escolaridadeTotemSlice';
import { desfazerConexao, fetchLogin } from '../../app/slices/loginSlice';
import {
  abrirModalBairro, abrirModalComoSoube, abrirModalEscolaridade, abrirModalSexo,
} from '../../app/slices/modalSlice';
import { desfazerSecretaria } from '../../app/slices/secretariasSlice';
import { desfazerSexo, selectSexoTotem } from '../../app/slices/sexoTotemSlice';
import {
  Alerta,
  Container, ContainerCadastroTotem, ContainerTotem, Divisor, FormFooterTotem, Interno, Titulo,
} from '../../styles/base';
import {
  cep, cnpj, cpf, date, email, isCNPJ, name, number, rg, sus, tel,
} from '../../util/mascaras';
import { replaceEspeciais } from '../../util/stringFactory';
import Botao from '../Botao/Botao';
import Carregar from '../Carregar/Carregar';
import FormControl from '../FormControl/FormControl';
import {
  LinhaForm, LinhaFormTotem, LinhaFormTotemCadastro, LinhaFormTotemUmaLinha,
} from '../FormControl/FormControlEstilo';
import { espacamento } from '../../styles/constants/sizes';

const defaultValues = {
  Solicitante: '',
  SolicitanteSocial: '',
  Turista: 'N',
  IdEstadoTurista: '',
  IdCidadeTurista: '',
  BairroTurista: '',
  CEP: '',
  Endereco: '',
  Numero: '',
  Complemento: '',
  Telefone01: '',
  Telefone02: '',
  Telefone03: '',
  Sexo: '',
  IdGrauEscolaridade: '',
  RG: '',
  CPFCNPJ: '',
  Email: '',
  Palavra: '',
  PalavraConfirmacao: '',
  IdComoFicouSabendo: '',
  cartaoSus: '',
  CoronavirusRendaMensal: '',
  CoronavirusQuantosMembrosRecebemBolsaFamilia: '',
  CoronavirusQuantosDiasSemTrabalhar: '',
  CoronavirusQuantosMembrosPossuemAtividadeProdutiva: '',
  CoronavirusQuantidadeMembrosFamilia: '',
  CoronavirusTrabalhoRegistrado: '',
  ReceberNews: '',
  ConselhoOuvidoria: '',
  TermosAplicativo: '',
};

const bool = [
  {
    Id: 'S',
    Campo: 'Sim',
  },
  {
    Id: 'N',
    Campo: 'Não',
  },
];

const boolSexo = [
  {
    Id: 'M',
    Campo: 'Masculino',
  },
  {
    Id: 'F',
    Campo: 'Feminino',
  },
  {
    Id: 'O',
    Campo: 'Outros',
  },
];

const coronaNumeros = [
  {
    Id: '0',
    Campo: '0',
  },
  {
    Id: '1',
    Campo: '1',
  },
  {
    Id: '2',
    Campo: '2',
  },
  {
    Id: '3',
    Campo: '3',
  },
  {
    Id: '4',
    Campo: '4',
  },
  {
    Id: '5',
    Campo: '5',
  },
  {
    Id: '6',
    Campo: '6',
  },
  {
    Id: '7',
    Campo: '7',
  },
  {
    Id: '8',
    Campo: '8',
  },
  {
    Id: '9',
    Campo: '9',
  },
  {
    Id: '10',
    Campo: '10',
  },
  {
    Id: '11',
    Campo: '11',
  },
  {
    Id: '12',
    Campo: '12',
  },
  {
    Id: '13',
    Campo: '13',
  },
  {
    Id: '14',
    Campo: '14',
  },
  {
    Id: '15',
    Campo: '15',
  },
  {
    Id: '16',
    Campo: '16',
  },
  {
    Id: '17',
    Campo: '17',
  },
  {
    Id: '18',
    Campo: '18',
  },
  {
    Id: '19',
    Campo: '19',
  },
  {
    Id: '20',
    Campo: '20',
  },
];

const FormularioUsuarioCadastroTotem = ({ sic, ouvidoria, zeladoria }) => {
  const [listaEstadosTurismo, setListaEstadosTurismo] = useState(null);
  const [listaCidadesTurismo, setListaCidadesTurismo] = useState(null);
  const [listaCampos, setListaCampos] = useState(null);
  const [listaBairros, setListaBairros] = useState(null);
  const [listaEscolaridades, setListaEscolaridades] = useState(null);
  const [listaFicouSabendo, setListaFicouSabendo] = useState(null);
  const [values, setValues] = useState(defaultValues);
  const [carregando, setCarregando] = useState(false);
  const [tipoCampoSenha, setTipoCampoSenha] = useState('senhaTotemCadastro');
  const [tipoCampoConfirmacaoSenha, setTipoCampoConfirmacaoSenha] = useState('senhaTotemCadastro');

  const dispatch = useDispatch();
  const alert = useAlert();
  const history = useHistory();
  const dadosCidade = useSelector(selectCidade);
  const { bairroTotem } = useSelector(selectBairroTotem);
  const { sexoTotem } = useSelector(selectSexoTotem);
  const { escolaridadeTotem } = useSelector(selectEscolaridadeTotem);
  const { comoSoubeTotem } = useSelector(selectComoSoubeTotem);

  useEffect(() => {
    Promise.all([
      fetchSolicitanteCamposTotem(),
      fetchBairros(),
      fetchEscolaridades(),
      fetchFicouSabendo(),
      fetchEstadosTurismo(),
    ]).then(([dadosSolicitanteCampos, dadosBairros, dadosEscolaridades,
      dadosFicouSabendo, dadosEstadosTurismo]) => {
      setListaCampos(dadosSolicitanteCampos);
      setListaBairros(dadosBairros);
      setListaEscolaridades(dadosEscolaridades);
      setListaFicouSabendo(dadosFicouSabendo);
      setListaEstadosTurismo(dadosEstadosTurismo);
    });
    dispatch(desfazerBairro());
    dispatch(desfazerComoSoube());
    dispatch(desfazerSexo());
    dispatch(desfazerEscolaridade());
  }, []);

  useEffect(() => {
    setValues({ ...values, IdBairro: bairroTotem && bairroTotem.bairroId });
  }, [bairroTotem]);

  useEffect(() => {
    setValues({ ...values, IdSexo: sexoTotem && sexoTotem.sexoId });
  }, [sexoTotem]);

  useEffect(() => {
    setValues({ ...values, IdEscolaridade: escolaridadeTotem && escolaridadeTotem.escolaridadeId });
  }, [escolaridadeTotem]);

  useEffect(() => {
    setValues({ ...values, IdComoSoube: comoSoubeTotem && comoSoubeTotem.comoSoubeId });
  }, [comoSoubeTotem]);

  const setVal = (key, val) => setValues({
    ...values, [key]: val,
  });

  if (!listaCampos || !listaFicouSabendo
    || !listaEscolaridades || !listaBairros || !listaEstadosTurismo) {
    return (
      <Carregar />
    );
  }

  if (listaCampos.Error
    || listaFicouSabendo.Error
    || listaEscolaridades.Error
    || listaBairros.Error
    || listaEstadosTurismo.Error) {
    history.push('/');
    dispatch(desfazerConexao());
    dispatch(desfazerCidade());
    dispatch(desfazerSecretaria());
    return (
      <Carregar />
    );
  }

  const emailCampo = listaCampos.find(({ NomeCampo }) => NomeCampo === 'Email');
  const idComoFicouSabendo = listaCampos.find(({ NomeCampo }) => NomeCampo === 'IdComoFicouSabendo');
  const idGrauEscolaridade = listaCampos.find(({ NomeCampo }) => NomeCampo === 'IdGrauEscolaridade');
  const sexo = listaCampos.find(({ NomeCampo }) => NomeCampo === 'Sexo');
  const dataNascimento = listaCampos.find(({ NomeCampo }) => NomeCampo === 'DataNascimento');
  const rgCampo = listaCampos.find(({ NomeCampo }) => NomeCampo === 'RG');
  const cpfcnpj = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CPFCNPJ');
  const endereco = listaCampos.find(({ NomeCampo }) => NomeCampo === 'Endereco');
  const numero = listaCampos.find(({ NomeCampo }) => NomeCampo === 'Numero');
  const complemento = listaCampos.find(({ NomeCampo }) => NomeCampo === 'Complemento');
  const cepCampo = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CEP');
  const telefone01 = listaCampos.find(({ NomeCampo }) => NomeCampo === 'Telefone01');
  const telefone02 = listaCampos.find(({ NomeCampo }) => NomeCampo === 'Telefone02');
  const telefone03 = listaCampos.find(({ NomeCampo }) => NomeCampo === 'Telefone03');
  const coronavirusRendaMensal = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CoronavirusRendaMensal');
  const coronavirusQuantosMembrosRecebemBolsaFamilia = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CoronavirusQuantosMembrosRecebemBolsaFamilia');
  const coronavirusQuantosDiasSemTrabalhar = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CoronavirusQuantosDiasSemTrabalhar');
  const coronavirusQuantosMembrosPossuemAtividadeProdutiva = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CoronavirusQuantosMembrosPossuemAtividadeProdutiva');
  const coronavirusQuantidadeMembrosFamilia = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CoronavirusQuantidadeMembrosFamilia');
  const coronavirusTrabalhoRegistrado = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CoronavirusTrabalhoRegistrado');
  const cartaoSus = listaCampos.find(({ NomeCampo }) => NomeCampo === 'CartaoSUS');
  const nomeSocial = listaCampos.find(({ NomeCampo }) => NomeCampo === 'NomeSocial');
  const resideForaDaCidade = listaCampos.find(({ NomeCampo }) => NomeCampo === 'ResideForaDaCidade');

  const validate = () => {
    if (!values.Solicitante) {
      alert.error('Verifique o campo nome.', { timeout: 5000 });
      return false;
    }
    if (!values.Solicitante.match(/[a-zA-Z]* [a-zA-Z]*/)) {
      alert.error('Preencha nome e sobrenome completo.', { timeout: 5000 });
      return false;
    }
    if (nomeSocial.Visivel === 'S' && nomeSocial.Nulo === 'S' && !values.SolicitanteSocial) {
      alert.error('Verifique o campo nome social.', { timeout: 5000 });
      return false;
    }
    if (cepCampo.Visivel === 'S' && cepCampo.Nulo === 'S' && !values.CEP) {
      alert.error('Verifique o campo CEP.', { timeout: 5000 });
      return false;
    }
    if (!values.IdBairro) {
      if (!values.BairroTurista) {
        alert.error('Verifique o campo bairro.', { timeout: 5000 });
        return false;
      }
    }
    if (endereco.Visivel === 'S' && endereco.Nulo === 'S' && !values.Endereco) {
      alert.error('Verifique o campo endereço.', { timeout: 5000 });
      return false;
    }
    if (numero.Visivel === 'S' && numero.Nulo === 'S' && !values.Numero) {
      alert.error('Verifique o campo número.', { timeout: 5000 });
      return false;
    }
    if (complemento.Visivel === 'S' && complemento.Nulo === 'S' && !values.Complemento) {
      alert.error('Verifique o campo complemento.', { timeout: 5000 });
      return false;
    }
    if (telefone01.Visivel === 'S' && telefone01.Nulo === 'S' && !values.Telefone01) {
      alert.error('Verifique o campo telefone.', { timeout: 5000 });
      return false;
    }
    if (telefone02.Visivel === 'S' && telefone02.Nulo === 'S' && !values.Telefone02) {
      alert.error('Verifique o campo telefone secundário.', { timeout: 5000 });
      return false;
    }
    if (telefone03.Visivel === 'S' && telefone03.Nulo === 'S' && !values.Telefone03) {
      alert.error('Verifique o campo outro telefone.', { timeout: 5000 });
      return false;
    }
    if (coronavirusRendaMensal.Visivel === 'S' && coronavirusRendaMensal.Nulo === 'S' && !values.CoronavirusRendaMensal) {
      alert.error('Verifique o campo renda mensal.', { timeout: 5000 });
      return false;
    }
    if (coronavirusQuantosMembrosRecebemBolsaFamilia.Visivel === 'S' && coronavirusQuantosMembrosRecebemBolsaFamilia.Nulo === 'S' && !values.CoronavirusQuantosMembrosRecebemBolsaFamilia) {
      alert.error('Verifique todos os campos obrigatórios.', { timeout: 5000 });
      return false;
    }
    if (coronavirusQuantosDiasSemTrabalhar.Visivel === 'S' && coronavirusQuantosDiasSemTrabalhar.Nulo === 'S' && !values.CoronavirusQuantosDiasSemTrabalhar) {
      alert.error('Verifique todos os campos obrigatórios.', { timeout: 5000 });
      return false;
    }
    if (coronavirusQuantosMembrosPossuemAtividadeProdutiva.Visivel === 'S' && coronavirusQuantosMembrosPossuemAtividadeProdutiva.Nulo === 'S' && !values.CoronavirusQuantosMembrosPossuemAtividadeProdutiva) {
      alert.error('Verifique todos os campos obrigatórios.', { timeout: 5000 });
      return false;
    }
    if (coronavirusQuantidadeMembrosFamilia.Visivel === 'S' && coronavirusQuantidadeMembrosFamilia.Nulo === 'S' && !values.CoronavirusQuantidadeMembrosFamilia) {
      alert.error('Verifique todos os campos obrigatórios.', { timeout: 5000 });
      return false;
    }
    if (coronavirusTrabalhoRegistrado.Visivel === 'S' && coronavirusTrabalhoRegistrado.Nulo === 'S' && !values.CoronavirusTrabalhoRegistrado) {
      alert.error('Verifique todos os campos obrigatórios.', { timeout: 5000 });
      return false;
    }
    if (dataNascimento.Visivel === 'S' && dataNascimento.Nulo === 'S' && !values.DataNascimento) {
      alert.error('Verifique o campo data de nascimento.', { timeout: 5000 });
      return false;
    }
    if (sexo.Visivel === 'S' && sexo.Nulo === 'S' && !values.Sexo) {
      alert.error('Verifique o campo sexo.', { timeout: 5000 });
      return false;
    }
    if (idGrauEscolaridade.Visivel === 'S' && idGrauEscolaridade.Nulo === 'S' && !values.IdGrauEscolaridade) {
      alert.error('Verifique o campo escolaridade.', { timeout: 5000 });
      return false;
    }
    if (rgCampo.Visivel === 'S' && rgCampo.Nulo === 'S' && !values.RG) {
      alert.error('Verifique o campo RG.', { timeout: 5000 });
      return false;
    }
    if (cpfcnpj.Visivel === 'S' && cpfcnpj.Nulo === 'S' && !values.CPFCNPJ) {
      alert.error('Verifique o campo CPF/CNPJ.', { timeout: 5000 });
      return false;
    }
    if (cartaoSus.Visivel === 'S' && cartaoSus.Nulo === 'S' && !values.cartaoSus) {
      alert.error('Verifique o campo cartão SUS.', { timeout: 5000 });
      return false;
    }
    if (emailCampo.Visivel === 'S' && emailCampo.Nulo === 'S' && !values.Email) {
      alert.error('Verifique o campo E-mail.', { timeout: 5000 });
      return false;
    }
    if (!values.Palavra) {
      alert.error('Verifique o campo senha.', { timeout: 5000 });
      return false;
    }
    if (values.PalavraConfirmacao !== values.Palavra) {
      alert.error('A confirmação de senha é diferente da senha inserida.', { timeout: 5000 });
      return false;
    }
    if (idComoFicouSabendo.Visivel === 'S' && idComoFicouSabendo.Nulo === 'S' && !values.IdComoFicouSabendo) {
      alert.error('Verifique todos os campos obrigatórios.', { timeout: 5000 });
      return false;
    }
    return true;
  };

  const getIdBairro = (nomeBairro) => {
    if (!listaBairros) {
      return 'null';
    }

    const bairro = listaBairros.find(({ Campo }) => Campo === nomeBairro);
    if (!bairro) {
      return '';
    }
    return bairro.Id;
  };

  const buscarCep = async () => {
    const busca = values.CEP;

    if (busca.length === 8) {
      const resultado = await apiCep(busca);

      if (resultado.erro) {
        return alert.error('CEP não encontrado.', { timeout: 5000 });
      }

      return setValues({
        ...values,
        Endereco: resultado.logradouro,
        IdBairro: getIdBairro(resultado.bairro),
      });
    }

    return alert.error('Número de CEP inválido.', { timeout: 5000 });
  };

  const handleVoltar = () => {
    if (ouvidoria) {
      history.push('/totem/ouvidoria/cadastrar/escolhalogin');
    }
    if (sic) {
      history.push('/totem/sic/cadastrar/escolhalogin');
    }
    if (zeladoria) {
      history.push('/totem/zeladoria/cadastrar/escolhalogin');
    }
  };

  const cadastrarSolicitante = async (event) => {
    event.preventDefault();
    setCarregando(true);

    if (!validate()) {
      setCarregando(false);
      return;
    }

    if (values.Palavra && values.Palavra.length < 6) {
      setCarregando(false);
      alert.error('A senha digitada deve ser maior do que 6 caracteres.', { timeout: 5000 });
      return;
    }

    const resposta = await postCadastrarSolicitanteTotem({
      ...values,
      OrigemCadastro: 'W',
      CoronavirusRendaMensal: values.CoronavirusRendaMensal ? values.CoronavirusRendaMensal.substring(3, 12) : '',
    });

    if (resposta.Error) {
      setCarregando(false);
      alert.error(resposta.Error, { timeout: 5000 });
      return;
    }

    setCarregando(false);

    alert.success('Cadastro realizado. Comece a usar o aplicativo imediatamente.', { timeout: 5000 });

    await dispatch(fetchLogin({
      username: values.Email ? values.Email : values.CPFCNPJ,
      password: values.Palavra,
    }));

    setValues(defaultValues);

    if (ouvidoria) {
      history.push('/totem/ouvidoria/cadastrar');
    }
    if (sic) {
      history.push('/totem/sic/cadastrar');
    }
    if (zeladoria) {
      history.push('/totem/zeladoria/cadastrar');
    }
  };

  const manipularTipoCampoSenha = () => {
    if (tipoCampoSenha === 'senhaTotemCadastro') {
      setTipoCampoSenha('inputTotemVisualizacao');
    } else {
      setTipoCampoSenha('senhaTotemCadastro');
    }
  };

  const manipularTipoCampoConfirmacaoSenha = () => {
    if (tipoCampoConfirmacaoSenha === 'senhaTotemCadastro') {
      setTipoCampoConfirmacaoSenha('inputTotemVisualizacao');
    } else {
      setTipoCampoConfirmacaoSenha('senhaTotemCadastro');
    }
  };

  return (
    <ContainerCadastroTotem style={{ marginTop: 80, paddingInline: 95 }} totem>
      <Botao
        voltar
        label="Voltar"
        style={{
          marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
        }}
        onClick={() => handleVoltar()}
      />
      <Alerta style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <strong style={{ fontSize: '1.3em' }}>* Os campos com asterisco são obrigatórios.</strong>
      </Alerta>

      <Divisor style={{ marginBottom: 6, paddingBottom: 6 }} />

      <form id="teste1234">
        <LinhaFormTotemUmaLinha>
          <FormControl
            idCampo="inputSolicitante"
            value={values.Solicitante && name(values.Solicitante)}
            label="Nome:"
            onChange={({ target }) => setVal('Solicitante', target.value)}
            required
            type="inputTotem"
          />

          {nomeSocial && nomeSocial.Visivel === 'S' && (
            <FormControl
              idCampo="inputSolicitanteSocial"
              value={values.SolicitanteSocial && name(values.SolicitanteSocial)}
              label="Nome social:"
              onChange={({ target }) => setVal('SolicitanteSocial', target.value)}
              type="inputTotem"
              required={nomeSocial.Nulo === 'S'}
            />
          )}
        </LinhaFormTotemUmaLinha>

        <LinhaFormTotemCadastro>
          {resideForaDaCidade && resideForaDaCidade.Visivel === 'S' && (
            <FormControl
              idCampo="selectTurista"
              value={values.Turista}
              label="Reside fora da cidade?"
              noBlank
              options={bool}
              type="selectTotem"
              onChange={({ target }) => {
                setValues({
                  ...values,
                  IdBairro: '',
                  IdEstadoTurista: '',
                  IdCidadeTurista: '',
                  BairroTurista: '',
                  Turista: target.value,
                });
              }}
            />
          )}

          {(values && values.Turista === 'S') && (resideForaDaCidade && resideForaDaCidade.Visivel === 'S') && (
            <>
              <FormControl
                idCampo="selectEstadoTurista"
                value={values.IdEstadoTurista}
                label="Estado:"
                options={listaEstadosTurismo}
                onChange={({ target }) => {
                  setVal('IdEstadoTurista', target.value);
                  fetchCidadesTurismo(target.value).then((data) => setListaCidadesTurismo(data));
                }}
                type="selectTotem"
              />

              <FormControl
                idCampo="selectCidadeTurista"
                value={values.IdCidadeTurista}
                label="Cidade:"
                options={listaCidadesTurismo}
                onChange={({ target }) => setVal('IdCidadeTurista', target.value)}
                type="selectTotem"
              />
            </>
          )}
        </LinhaFormTotemCadastro>

        <LinhaFormTotemCadastro>
          {cepCampo.Visivel === 'S' && (
            <FormControl
              idCampo="inputCep"
              value={values.CEP && cep(values.CEP)}
              label="CEP:"
              type="cepTotem"
              busca={endereco.Visivel === 'S'}
              onChange={({ target }) => setVal('CEP', replaceEspeciais(target.value))}
              maxLength={9}
              required={cepCampo.Nulo === 'S'}
              onClick={buscarCep}
            />
          )}
        </LinhaFormTotemCadastro>
        <LinhaForm>
          {endereco.Visivel === 'S' && (
            <FormControl
              idCampo="inputEndereco"
              value={values.Endereco}
              label="Endereço:"
              onChange={({ target }) => setVal('Endereco', target.value)}
              required={endereco.Nulo === 'S'}
              type="inputTotem"
            />
          )}
        </LinhaForm>
        <LinhaFormTotemCadastro>
          {(values && values.Turista === 'N')
            ? (
              <FormControl
                idCampo="selectBairro"
                value={(bairroTotem && bairroTotem.bairro && bairroTotem.bairro !== '' && bairroTotem.bairro) || values.IdBairro}
                type="selectBairrosTotem"
                label="Bairro:"
                onChange={({ target }) => setVal('IdBairro', target.value)}
                required
                placeholder="Selecione"
                onClick={(e) => { dispatch(abrirModalBairro({ bairros: listaBairros })); e.target.blur(); }}
              />
            )
            : (
              <FormControl
                idCampo="inputBairroTurista"
                value={values.BairroTurista}
                label="Bairro:"
                onChange={({ target }) => setVal('BairroTurista', target.value)}
                required
                type="inputTotem"
              />
            )}
          {numero.Visivel === 'S' && (
            <FormControl
              idCampo="inputNumero"
              value={values.Numero && number(values.Numero)}
              label="Número:"
              onChange={({ target }) => setVal('Numero', target.value)}
              maxLength={5}
              required={numero.Nulo === 'S'}
              type="inputTotem"
            />
          )}

          {complemento.Visivel === 'S' && (
            <FormControl
              idCampo="inputComplemento"
              value={values.Complemento}
              label="Complemento:"
              onChange={({ target }) => setVal('Complemento', target.value)}
              required={complemento.Nulo === 'S'}
              type="inputTotem"
            />
          )}

          {telefone01.Visivel === 'S' && (
            <FormControl
              idCampo="inputTelefone01"
              value={values.Telefone01 && tel(values.Telefone01)}
              label="Telefone principal:"
              onChange={({ target }) => setVal('Telefone01', replaceEspeciais(target.value))}
              required={telefone01.Nulo === 'S'}
              type="inputTotem"
            />
          )}

          {telefone02.Visivel === 'S' && (
            <FormControl
              idCampo="inputTelefone02"
              value={values.Telefone02 && tel(values.Telefone02)}
              label="Telefone secundário:"
              onChange={({ target }) => setVal('Telefone02', replaceEspeciais(target.value))}
              required={telefone02.Nulo === 'S'}
              type="inputTotem"
            />
          )}

          {telefone03.Visivel === 'S' && (
            <FormControl
              idCampo="inputTelefone03"
              value={values.Telefone03 && tel(values.Telefone03)}
              label="Outro telefone / recado:"
              onChange={({ target }) => setVal('Telefone03', replaceEspeciais(target.value))}
              required={telefone03.Nulo === 'S'}
              type="inputTotem"
            />
          )}

          {dataNascimento.Visivel === 'S' && (
            <FormControl
              idCampo="inputDataNascimento"
              value={values.DataNascimento && date(values.DataNascimento)}
              label="Data de nascimento:"
              onChange={({ target }) => setVal('DataNascimento', target.value)}
              required={dataNascimento.Nulo === 'S'}
              type="inputTotem"
            />
          )}

          {sexo.Visivel === 'S' && (
          // <FormControl
          //   idCampo="selectSexo"
          //   value={values.Sexo}
          //   type="select"
          //   label="Gênero"
          //   options={boolSexo}
          //   onChange={({ target }) => setVal('Sexo', target.value)}
          //   required={sexo.Nulo === 'S'}
          // />

          <FormControl
            idCampo="selectSexo"
            value={(sexoTotem && sexoTotem.sexo && sexoTotem.sexo !== '' && sexoTotem.sexo) || values.Sexo}
            type="selectBairrosTotem"
            label="Gênero:"
            onChange={({ target }) => setVal('Sexo', target.value)}
            required
            placeholder="Selecione"
            onClick={(e) => { dispatch(abrirModalSexo({ sexo: boolSexo })); e.target.blur(); }}
          />
          )}

          {idGrauEscolaridade.Visivel === 'S' && (
          // <FormControl
          //   idCampo="selectGrauEscolaridade"
          //   value={values.IdGrauEscolaridade}
          //   type="select"
          //   label="Escolaridade"
          //   options={listaEscolaridades}
          //   onChange={({ target }) => setVal('IdGrauEscolaridade', target.value)}
          //   required={idGrauEscolaridade.Nulo === 'S'}
          // />

            <FormControl
              idCampo="selectGrauEscolaridade"
              value={(escolaridadeTotem && escolaridadeTotem.escolaridade && escolaridadeTotem.escolaridade !== '' && escolaridadeTotem.escolaridade) || values.IdGrauEscolaridade}
              type="selectBairrosTotem"
              label="Escolaridade:"
              onChange={({ target }) => setVal('IdGrauEscolaridade', target.value)}
              required
              placeholder="Selecione"
              onClick={(e) => { dispatch(abrirModalEscolaridade({ escolaridade: listaEscolaridades })); e.target.blur(); }}
            />
          )}

          {rgCampo.Visivel === 'S' && (
            <FormControl
              idCampo="inputRg"
              value={values.RG && rg(values.RG)}
              label="RG:"
              onChange={({ target }) => setVal('RG', replaceEspeciais(target.value))}
              required={rgCampo.Nulo === 'S'}
              type="inputTotem"
            />
          )}

          {cpfcnpj.Visivel === 'S' && (
            <>
              {values.CPFCNPJ && isCNPJ(values.CPFCNPJ)
                ? (
                  <FormControl
                    idCampo="inputCpfCnpj"
                    value={values.CPFCNPJ && cnpj(values.CPFCNPJ)}
                    label="CPF/CNPJ:"
                    onChange={({ target }) => setVal('CPFCNPJ', target.value)}
                    required={cpfcnpj.Nulo === 'S'}
                    type="inputTotem"
                  />
                )
                : (
                  <FormControl
                    idCampo="inputCpfCnpj"
                    value={values.CPFCNPJ && cpf(values.CPFCNPJ)}
                    label="CPF/CNPJ:"
                    onChange={({ target }) => setVal('CPFCNPJ', target.value)}
                    required={cpfcnpj.Nulo === 'S'}
                    type="inputTotem"
                  />
                )}
            </>
          )}

          {cartaoSus.Visivel === 'S' && (
            <FormControl
              idCampo="inputSus"
              value={values.cartaoSus && sus(values.cartaoSus)}
              label="Cartão SUS:"
              onChange={({ target }) => setVal('cartaoSus', replaceEspeciais(target.value))}
              required={cartaoSus.Nulo === 'S'}
              type="inputTotem"
            />
          )}

          {coronavirusQuantidadeMembrosFamilia.Visivel === 'S' && (
            <FormControl
              idCampo="selectCoronavirusQuantidadeMembrosFamilia"
              value={values.CoronavirusQuantidadeMembrosFamilia}
              type="select"
              label="Quantidade de membros da família?"
              options={coronaNumeros}
              onChange={({ target }) => setVal('CoronavirusQuantidadeMembrosFamilia', target.value)}
              required={coronavirusQuantidadeMembrosFamilia.Nulo === 'S'}
            />
          )}

          {coronavirusQuantosMembrosPossuemAtividadeProdutiva.Visivel === 'S' && (
            <FormControl
              idCampo="selectCoronavirusQuantosMembrosPossuemAtividadeProdutiva"
              value={values.CoronavirusQuantosMembrosPossuemAtividadeProdutiva}
              type="select"
              label="Quantos membros possuem atividade produtiva?"
              options={coronaNumeros}
              onChange={({ target }) => setVal('CoronavirusQuantosMembrosPossuemAtividadeProdutiva', target.value)}
              required={coronavirusQuantosMembrosPossuemAtividadeProdutiva.Nulo === 'S'}
            />
          )}

          {coronavirusQuantosMembrosRecebemBolsaFamilia.Visivel === 'S' && (
            <FormControl
              idCampo="selectCoronavirusQuantosMembrosRecebemBolsaFamilia"
              value={values.CoronavirusQuantosMembrosRecebemBolsaFamilia}
              type="select"
              label="Membros que recebem bolsa família ou BPC (benefício de prestação continuada)?"
              options={coronaNumeros}
              onChange={({ target }) => setVal('CoronavirusQuantosMembrosRecebemBolsaFamilia', target.value)}
              required={coronavirusQuantosMembrosRecebemBolsaFamilia.Nulo === 'S'}
            />
          )}

          {coronavirusTrabalhoRegistrado.Visivel === 'S' && (
            <FormControl
              idCampo="selectCoronavirusTrabalhoRegistrado"
              value={values.CoronavirusTrabalhoRegistrado}
              label="Trabalho registrado?"
              options={bool}
              onChange={({ target }) => setVal('CoronavirusTrabalhoRegistrado', target.value)}
              type="select"
              required={coronavirusTrabalhoRegistrado.Nulo === 'S'}
            />
          )}

          {coronavirusQuantosDiasSemTrabalhar.Visivel === 'S' && (
            <FormControl
              idCampo="selectCoronavirusQuantosDiasSemTrabalhar"
              value={values.CoronavirusQuantosDiasSemTrabalhar}
              label="Quantos dias sem trabalhar?"
              options={coronaNumeros}
              onChange={({ target }) => setVal('CoronavirusQuantosDiasSemTrabalhar', target.value)}
              type="select"
              required={coronavirusQuantosDiasSemTrabalhar.Nulo === 'S'}
            />
          )}

          {coronavirusRendaMensal.Visivel === 'S' && (
            <FormControl
              idCampo="inputCoronavirusRendaMensal"
              label="Renda mensal:"
              value={values.CoronavirusRendaMensal}
              onChange={(val) => setVal('CoronavirusRendaMensal', val)}
              maxLength={12}
              type="money"
              required={coronavirusRendaMensal.Nulo === 'S'}
            />
          )}

        </LinhaFormTotemCadastro>

        <LinhaFormTotemCadastro>
          {emailCampo.Visivel === 'S' && (
          <FormControl
            idCampo="inputEmail"
            value={values.Email && email(values.Email)}
            label="E-mail:"
            onChange={({ target }) => setVal('Email', target.value)}
            required={emailCampo.Nulo === 'S'}
            type="inputTotem"
          />
          )}

          <div style={{ flex: 1, position: 'relative' }}>
            <FormControl
              idCampo="inputPalavra"
              value={values.Palavra}
              label="Senha:"
              onChange={({ target }) => setVal('Palavra', target.value)}
              type={tipoCampoSenha}
              required
            />

            <FormControl
              value={tipoCampoSenha}
              type="exibirSenha"
              altura="20"
              onClick={() => { manipularTipoCampoSenha(); }}
            />
          </div>

          <div style={{ flex: 1, position: 'relative' }}>
            <FormControl
              idCampo="inputPalavraConfirmacao"
              value={values.PalavraConfirmacao}
              label="Confirme a senha:"
              onChange={({ target }) => setVal('PalavraConfirmacao', target.value)}
              type={tipoCampoConfirmacaoSenha}
              required
            />

            <FormControl
              value={tipoCampoConfirmacaoSenha}
              type="exibirSenha"
              altura="20"
              onClick={() => { manipularTipoCampoConfirmacaoSenha(); }}
            />
          </div>

          {idComoFicouSabendo && idComoFicouSabendo.Visivel === 'S' && (
          <FormControl
            idCampo="selectComoFicouSabendo"
            value={(comoSoubeTotem && comoSoubeTotem.comoSoube && comoSoubeTotem.comoSoube !== '' && comoSoubeTotem.comoSoube) || values.IdComoFicouSabendo}
            type="selectBairrosTotem"
            label="Como soube deste aplicativo?"
            onChange={({ target }) => setVal('IdComoFicouSabendo', target.value)}
            required={idComoFicouSabendo.Nulo === 'S'}
            placeholder="Selecione"
            onClick={(e) => { dispatch(abrirModalComoSoube({ comoSoube: listaFicouSabendo })); e.target.blur(); }}
          />
          )}
        </LinhaFormTotemCadastro>

        <FormFooterTotem>
          {carregando !== true
            ? (
              <Botao
                style={{
                  fontSize: '1.53em',
                  padding: '20px 50px',
                  marginTop: 30,
                }}
                label="Enviar"
                type="submitTotem"
                onClick={cadastrarSolicitante}
              />
            )
            : (
              <Carregar />
            )}
        </FormFooterTotem>

      </form>
    </ContainerCadastroTotem>
  );
};

FormularioUsuarioCadastroTotem.propTypes = {
  ouvidoria: PropTypes.bool,
  sic: PropTypes.bool,
  zeladoria: PropTypes.bool,
};

FormularioUsuarioCadastroTotem.defaultProps = {
  ouvidoria: false,
  sic: false,
  zeladoria: false,
};

export default FormularioUsuarioCadastroTotem;
